import React from "react";
import { useTranslation } from "react-i18next";
import CoomingSoon from "../components/CoomingSoon";

function AppSettings() {
    const { t } = useTranslation();
    return <CoomingSoon />
}

export default AppSettings;
